import register from '../util/init';
import {findClosest, getOffset} from '../util/miscellaneous';

function contactInit (container) {
  container.querySelectorAll('.dealer-countries .country').forEach((country) => {
    // default to close
    country.classList.add('close');
    // bind click
    country.querySelector('h1').addEventListener('click', (e) => {
      if (country.classList.contains('close')) {
        country.classList.remove('close');
      } else {
        country.classList.add('close');
      }
    });
  });

  if (window.location.hash) {
    const hash = document.getElementById(window.location.hash.substring(1));
    if (hash) {
      const country = findClosest(hash, '.country');
      if (country) {
        country.classList.remove('close');
      }
    }
  }

  // bind change listener
  const regionSelector = container.querySelector('.region-selector select');
  if (regionSelector) {
    regionSelector.addEventListener('change', (e) => {
      const currentRegion = regionSelector.value;
      const target = document.getElementById(currentRegion);

      const country = findClosest(target, '.country');
      country.classList.remove('close');

      window.setTimeout(() => {
        window.scroll({
          top: getOffset(target).top,
          left: 0,
          behavior: 'smooth'
        });
      }, 400);
    });
  }
}

register('contact-article', contactInit);

export function dealerSelectorRedirect (dealerSelector) {
  if (dealerSelector) {
    const select = dealerSelector.querySelector('select');
    // bind change listener
    select.addEventListener('change', (e) => {
      const currentRegion = select.value;
      window.location = currentRegion;
    });
  }
}



// WEBPACK FOOTER //
// ./assets/j/src/contact.js